export const classes = {
  confirmWrapper: 'flex items-center',
  fullWidthSingle: 'grid grid-cols-1',
  fullWidthDual: 'grid grid-cols-2 gap-[10px]',
  fullWidthVertical: 'flex flex-col-reverse gap-[10px]',
  fill: 'w-full',
};
